import { NotificationDateGroupType } from '@features/notifications/models/notification-date-group';

export const NOTIFICATION_GROUP_NAMES: Record<NotificationDateGroupType, string> = {
    [NotificationDateGroupType.Today]: 'NOTIFICATION_BELL.TODAY',
    [NotificationDateGroupType.Yesterday]: 'NOTIFICATION_BELL.YESTERDAY',
    [NotificationDateGroupType.Older]: 'NOTIFICATION_BELL.OLDER',
    [NotificationDateGroupType.Latest]: 'NOTIFICATION_BELL.LATEST',
};